module.exports = __webpack_public_path__ + "static/media/Line.38afde6b.svg";